import * as React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

interface ConvertingImagePlaceholderProps {
	className?: string;
}

/**
 * Shown in the box a photo tile already reserved while its HEIC original is being converted to
 * a JPEG a browser can render — either by the backend or in this tab. Fills its parent, and
 * paints its own background so it reads the same on a transparent tile and a grey one.
 */
export const ConvertingImagePlaceholder: React.FC<ConvertingImagePlaceholderProps> = ({
	className = '',
}) => (
	<div
		className={`flex h-full w-full flex-col items-center justify-center gap-1 bg-grey-3 text-center ${className}`}
	>
		<Spin indicator={<LoadingOutlined style={{ fontSize: 18 }} spin />} />
		<div className="footnoteregular truncate px-1 text-character-secondary">Processing HEIC</div>
	</div>
);

export default ConvertingImagePlaceholder;
